import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { compose } from "redux";
import { convertStringToElements } from "@vds/html-parsers";
import { Line } from "@vds/lines";
import PropTypes from "prop-types";
import { setA11yContent } from "../../NavigationHelper/actions";
import { media } from "utils/style";
import { checkNestedObject } from "utils/checkNestedObject";
import CommonContainer from "common-components/Container";
import RectangleLoader from "common-components/RectangleLoader";
import { Tile as CommonTile } from "common-components/Tile";
import { ButtonWithArrowNew } from "common-components/Buttons";

import { setBaseURLForNonSecure } from "../../../../../Services/API";
// import FetchPageContent from "../../../../hoc/FetchPageContent";
import { fetchPageContent } from "../../DownloadAndDelete/actions";
import { ENDPOINTS } from "utils/endpoints";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions"
import { setBreadCrumbListInRedux } from "../../DownloadAndDelete/actions";
class GuestFlowLandingNew extends Component {
  state = {
    loading: true
  };

  componentDidMount() {

    setBaseURLForNonSecure();
    this.props.fetchPageContent(ENDPOINTS.FETCH_GUEST_FLOW_LANDING_NEW).then(() => {
      this.setState({ loading: false });
      if (checkNestedObject(this.props.pageContent, "breadCrumbs")) {
        const { breadCrumbs } = this.props.pageContent;
        this.props.setBreadCrumbListInRedux({ breadCrumbs: breadCrumbs });

        this.props.setBreadcrumbList([
          { label: breadCrumbs.landingPage, path: "/privacy/your-data" },
          { label: breadCrumbs.guestCustomers, path: "/privacy/your-data/guest-landing" },
        ]);
      }
      if (checkNestedObject(this.props.pageContent[0], "sc_pagetitle")) {
        this.props.setA11yContent("guest information", this.props.pageContent[0].sc_pagetitle);
      }
    });
  }

  componentWillUnmount() {
    this.props.setBreadcrumbList([]);
  }

  render() {
    if (this.state.loading) {
      return <RectangleLoader />;
    }
    const { pageContent } = this.props;
    const sectionList = pageContent.sections[0]
    return (
      <div>
        <Container>
          <H1>{sectionList[0].section_title}</H1>
          <Div >
            <div className="subContent">
              {convertStringToElements(sectionList[0].section_description)}
            </div>
          </Div>
          <H2>{convertStringToElements(sectionList[1].section_title)}</H2>
          {sectionList[1].links.map(link => {
            return (
              <Div key={link.text} >
                <div className="buttonContainer">
                  <ButtonWithArrowNew
                    role="link"
                    descrition={link.desc}
                    onClick={() => this.props.history.push({ pathname: link.link, state: { isGuestFlow: true, serviceType: "guest" } })}
                  >
                    {link.text}
                  </ButtonWithArrowNew>
                  {link.text !== "Delete advertising information" ?
                  <Line style={{marginTop:"1.5rem"}} type="secondary"/> : ""}
                </div>
              </Div>
            )
          }
          )}

          <H3 style={{ margin: "64px 0 28px 0" }}>
            {convertStringToElements(sectionList[1].tileContent[0].title)}
          </H3>

          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {sectionList[1].tileContent[0].list.map(tile => (
              <Tile key={tile.heading} href={tile.tileLink} linkText={tile.linkText} >
                {tile.heading}
              </Tile>

            ))}
          </div>
        </Container>

      </div>
    );
  }
}

const mapStateToProps = ({ pageContent }) => ({
  pageContent
});

GuestFlowLandingNew.propTypes = {
  setA11yContent: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};


export default connect(
  mapStateToProps,
  { setA11yContent, fetchPageContent, setBreadcrumbList, setBreadCrumbListInRedux }
)(GuestFlowLandingNew);


const H2 = styled.h2`
font-style: normal;
font-weight: 700;
font-size: 32px;
line-height: 36px;
margin-top:64px;
font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
${media.mobile`
font-size: 24px;
line-height: 28px;
`}
`;

const H1 = styled.h1`
  font-size: 48px;
  line-height: 48px;
  width:597px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 300;
  ${media.mobile`
   max-width: 100%;
   font-style: normal;
   font-weight: 400;
   font-size: 32px;
  line-height: 36px;
`}

`;

const H3 = styled.h3`
  font-size: 32px;
  line-height: 36px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 700;
  ${media.mobile`
  font-size: 24px;
`}


  span {
    height: 5px;
    display: block;
    width: 49px;
    background-color: #d52b1e;
    margin-top: 16px;
  }
`;


const Tile = styled(CommonTile)`
  flex-basis: 48%;  
  margin-right:24px;
  background-color:#F6F6F6;
  span.tile_desc{
  max-width:548px;
  font-family: 'Verizon-NHG-eTX', Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  }

  span.tile_text{
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 700; 
    font-size: 20px;
    line-height: 24px;
    ${media.mobile`
    font-size: 16px;
  `}
}


  ${media.mobile`
    flex-basis: 100%;
    margin-right:0px
  `}
`;

const Div = styled.div`
div.subContent {
  max-width: 597px;
  margin-top:32px;
  p {
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 2px;
  }
  p:first-of-type {
   margin-bottom: 16px;
  }
  ul{
    margin-bottom: 20px !important;
  }
  li{
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    }
  ${media.mobile`
   max-width: 100%;
   p{
    font-size: 16px;
   }
   
`}
}

div.buttonContainer {
  margin-top:25px;
  width:597px;
  ${media.mobile`
   max-width: 100%;;
`}
}
`;
const Container = styled(CommonContainer)`
  padding: 64px 20px ;
  max-width:1272px;
  margin:0 0 20 0;
  ${media.mobile`
    padding: 48px 16px ;
  `}
`;